<template>
  <section class="confirmed">
    <header class="confirmed__header z-1">
      <div class="confirmed__header__content">
        <a :href="linkHome">
          <img src='~@/assets/paguemenos.png' alt="Logo Pague Menos"  height="62" />
        </a>
      </div>
    </header>
    <div class="confirmed__body">
      <div>
        <h1 class="confirmed__title">Enviado com sucesso ;)</h1>
        <p class="confirmed__desc">
          Para: {{ shippingDetails.email || shippingDetails.phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3') }}
          <br /><br />
          Peça ao cliente que siga as instruções via <strong>{{ shippingDetails.type }}</strong> de pagamento para concluir a compra com segurança.
        </p>
        <cp-button
          class="confirmed__btn"
          label="Realizar uma nova cotação"
          theme="outlined"
          size="medium"
          @onClick="nextStep"
        />
      </div>

      <img class="confirmed__img" src="https://ciclic.imgix.net/homes/pagueMenos/illustrations/hero--blue.webp?auto=format&w=354&h=240" alt="mulher fazendo gesto de &quot;ok&quot;" />
    </div>
  </section>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import cpButton from '@/components/atoms/Button.vue'
import dataLayer from '@/utils/data-layer'

export default {
  name: 'Confirmed',
  components: {
    cpButton
  },
  data () {
    return {}
  },
  created () {
    if (!this.uuid) {
      this.$router.push({ name: 'checkout' })
    }
  },
  mounted () {
    dataLayer('saude-semprebem', 'saude-envio-cotacao', 'click', '2-continuar')
  },
  computed: {
    ...mapState('sendQuotation', ['uuid', 'shippingDetails']),
    linkHome () {
      return process.env.VUE_APP_URL_HOME
    }
  },
  methods: {
    ...mapMutations('steps', ['resetSteps']),
    ...mapMutations('validatedSteps', ['resetValidateSteps']),
    ...mapMutations('personalData', ['resetPersonalData']),
    ...mapMutations('address', ['resetAddress']),
    nextStep () {
      window.sessionStorage.removeItem('semprebem:product')
      window.sessionStorage.removeItem('semprebem:checkout')

      this.resetSteps()
      this.resetValidateSteps()
      this.resetPersonalData()
      this.resetAddress()

      this.$router.push({ name: 'personal-data' })
    }
  }
}
</script>
  <style>
    #app {
      background-color: #F5F7FA;
    }
  </style>
  <style lang="scss" scoped>
    @import "@/assets/style/_variables";

    .confirmed {
      &__header {
        background-color: #ffffff;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
        height: 82px;
        position: relative;
        width: 100%;

        &__content {
          align-items: center;
          display: flex;
          justify-content: center;
          height: 100%;
          margin: 0 auto;
          max-width: 1313px;
          padding-left: 16px;
          width: 100%;

          @media screen and (min-width: 840px) and (max-width: 1366px) {
            padding-left: 80px;
          }
        }
      }

      &__body {
        align-items: center;
        display: flex;
        flex-flow: wrap;
        justify-content: center;
        min-height: calc(100vh - 112px);
        margin-left: 16px;
        margin-right: 16px;
      }

      &__title {
        color: #444;
        font-size: 40px;
        line-height: 48px;
        margin-bottom: 24px;
      }

      &__desc {
        color: #535355;
        font-family: $rubik-font-family;
        font-size: 18px;
        font-weight: 400;
        line-height: 26px;
        margin-bottom: 40px;
        max-width: 477px;
      }

      &__btn {
        max-width: 255px;
      }

      &__img {
        width: 100%;
        max-width: 354px;
      }
    }
  </style>
